import { frontendURL } from '../../../../helper/URLHelper';

import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';

// Cadastro de parceiros/destinos de pendência (Bloco 2 / T-06, admin).
export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/parceiros'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'fandata_parceiros',
          meta: {
            permissions: ['administrator'],
          },
          component: Index,
        },
      ],
    },
  ],
};
